var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/assign_custom" } } },
              [_c("div", { staticClass: "div2" }, [_vm._v("分配客户")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "query" },
      [
        _c("div", { staticClass: "header" }, [
          _c("span", [_vm._v("查询客户")]),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.show3,
                  expression: "!show3",
                },
              ],
              on: {
                click: function ($event) {
                  _vm.show3 = true
                },
              },
            },
            [_vm._v("收起")]
          ),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show3,
                  expression: "show3",
                },
              ],
              on: {
                click: function ($event) {
                  _vm.show3 = false
                },
              },
            },
            [_vm._v("展开")]
          ),
        ]),
        _c("el-collapse-transition", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.show3,
                  expression: "!show3",
                },
              ],
              staticClass: "polling",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    inline: true,
                    model: _vm.queryForm,
                    "label-width": "",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "信息" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入客户手机号码" },
                        model: {
                          value: _vm.queryForm.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "info", $$v)
                          },
                          expression: "queryForm.info",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "selectDate" }, [
                    _c("span", [_vm._v("时间")]),
                    _c(
                      "div",
                      { staticClass: "picker" },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            "unlink-panels": "",
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy- MM- dd",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { input: _vm.immediUpdate },
                          model: {
                            value: _vm.date,
                            callback: function ($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "入线方式" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "选择入线方式",
                            clearable: "",
                            filterable: "",
                            "default-first-option": true,
                          },
                          model: {
                            value: _vm.queryForm.Incoming,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "Incoming", $$v)
                            },
                            expression: "queryForm.Incoming",
                          },
                        },
                        _vm._l(_vm.line, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.name, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客服",
                            filterable: "",
                            clearable: "",
                            "default-first-option": true,
                          },
                          model: {
                            value: _vm.queryForm.service,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "service", $$v)
                            },
                            expression: "queryForm.service",
                          },
                        },
                        _vm._l(_vm.customer, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: { label: items.reallyName, value: items.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户等级" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客户等级",
                            clearable: "",
                            filterable: "",
                            "default-first-option": true,
                          },
                          model: {
                            value: _vm.queryForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "category", $$v)
                            },
                            expression: "queryForm.category",
                          },
                        },
                        _vm._l(_vm.rank, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "部门选择" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.queryForm.orgName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "orgName", $$v)
                          },
                          expression: "queryForm.orgName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "地区" } },
                    [
                      _c("levelAddr", {
                        staticClass: "addressContent",
                        attrs: {
                          province: _vm.queryForm.province,
                          city: _vm.queryForm.city,
                          area: _vm.queryForm.area,
                        },
                        on: {
                          updateprovice: _vm.getProvince,
                          updatecity: _vm.getCity,
                          updatearea: _vm.getArea,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.searchEvent()
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        { attrs: { plain: "" }, on: { click: _vm.reset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table" },
      [
        _vm.parArray.indexOf("addCustomerCode") != -1
          ? _c(
              "el-button",
              {
                staticStyle: { "margin-bottom": "10px" },
                attrs: { type: "primary" },
                on: { click: _vm.addCustomer },
              },
              [_vm._v("添加客户")]
            )
          : _vm._e(),
        _c(
          "vxe-table",
          {
            staticStyle: { width: "100%" },
            attrs: { align: "center", data: _vm.tableData.list },
          },
          [
            _c("vxe-table-column", {
              attrs: { type: "seq", title: "序号", width: "50" },
            }),
            _c("vxe-table-column", {
              attrs: { title: "姓名", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "nameClick",
                          on: {
                            click: function ($event) {
                              return _vm.toInformation(scope.row)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(scope.row.userName) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: { field: "phone", title: "手机号码", "min-width": "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.is_null(scope.row.phoneTwo)
                        ? _c("p", [_vm._v(_vm._s(scope.row.phone))])
                        : _c("div", [
                            _c("div", [_vm._v(_vm._s(scope.row.phone))]),
                            _c("div", [_vm._v(_vm._s(scope.row.phoneTwo))]),
                          ]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "address",
                title: "地址",
                "show-overflow": "",
                "min-width": "180",
              },
            }),
            _c("vxe-table-column", {
              attrs: { title: "客户等级", "min-width": "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.is_null(scope.row.userLevel)
                        ? _c("p", [_vm._v("--")])
                        : _c("p", [_vm._v(_vm._s(scope.row.userLevel))]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "userLevel",
                title: "客户等级/意向",
                "min-width": "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.is_null(scope.row.userLevel)
                        ? _c("p", [_vm._v("--")])
                        : _c("p", [_vm._v(_vm._s(scope.row.userLevel))]),
                      _vm.is_null(scope.row.userIntention)
                        ? _c("span", [_vm._v("--")])
                        : _c("span", [_vm._v(_vm._s(scope.row.userIntention))]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "customerName",
                title: "客服人员",
                "min-width": "110",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "ditchTime",
                title: "入线渠道/时间",
                "show-overflow": "",
                "min-width": "120",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm.is_null(scope.row.userDitch)
                        ? _c("p", [_vm._v("--")])
                        : _c("p", [_vm._v(_vm._s(scope.row.userDitch))]),
                      _vm.is_null(scope.row.ditchTime)
                        ? _c("p", [_vm._v("--")])
                        : _c("p", [_vm._v(_vm._s(scope.row.ditchTime))]),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: { title: "操作", "min-width": "220", fixed: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "添加订单",
                            placement: "top-start",
                          },
                        },
                        [
                          _vm.parArray.indexOf("mcAddorderAssign") != -1
                            ? _c(
                                "p",
                                {
                                  staticClass: "operation",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toAddOrder(scope.row)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("添单")])]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "编辑",
                            placement: "top-start",
                          },
                        },
                        [
                          _vm.parArray.indexOf("btnEditCodeAssign") != -1
                            ? _c(
                                "p",
                                {
                                  staticClass: "operation",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toInformation(scope.row)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("编辑")])]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "收货地址",
                            placement: "top-start",
                          },
                        },
                        [
                          _vm.parArray.indexOf("mcAddressAssign") != -1
                            ? _c(
                                "p",
                                {
                                  staticClass: "operation",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toAddress(scope.row)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("地址")])]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "历史订单记录",
                            placement: "top-start",
                          },
                        },
                        [
                          _vm.parArray.indexOf("mcOrderAssign") != -1
                            ? _c(
                                "p",
                                {
                                  staticClass: "operation",
                                  on: {
                                    click: function ($event) {
                                      return _vm.tolist(scope.row)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("历史")])]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm.tableData.totalNum > 0
          ? _c("div", { staticClass: "page" }, [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage1,
                      "page-sizes": [10, 20, 50, 100, 200],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.totalNum,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }